import { useQuery } from 'react-query';
import { RoutingReceipt } from '../types';
import { GetRoutingReceiptFromUrlParams, getRoutingReceiptsFromUrl } from '../clients/routingReceipts';
import { RoutingUIError } from '../components/ErrorBoundary/RoutingUIError';

type UseGetRoutingReceiptsFromUrlParams = GetRoutingReceiptFromUrlParams & {
  enabled: boolean;
  onError: (error: RoutingUIError | Error) => void;
  onSuccess?: (data: RoutingReceipt[] | undefined) => void;
};

export const useGetRoutingReceiptsFromUrl = (props: UseGetRoutingReceiptsFromUrlParams) => {
  return useQuery<RoutingReceipt[] | undefined, Error>(
    ['routingReceipts', props.routingReceiptsUrl],
    () => getRoutingReceiptsFromUrl(props),
    { enabled: props.enabled, onError: props.onError, onSuccess: props.onSuccess },
  );
};
